<bn-loading-overlay></bn-loading-overlay>
<h5>Subscrição de cotas</h5>
<div class="container">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" >
        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>
            <div *ngIf="podeCadastrarSubscricao" class="col-auto">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/habilitacao/subscricao/novo']"
                  ngbTooltip="Selecione esta opção para incluir Subscrição de Cotas."><i class="fa fa-file-signature">
                  </i> Cadastrar subscrição
                </button>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>
            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false)" (click)="buscar(false)"
                    [disabled]="!pesquisaForm.valid" >Pesquisar
                </button>
            </div>
        </div>
        <div class="row mt-4">
            <div class="bn-form-group col-md-4">
                <app-select-cotista
                    [labelForm]="true"
                    [nomeNaLabel]="false"
                    [cnpjNaLabel]="false"
                    tipoOrdenacaoEPesquisa="sigla"
                    (selecionado)="selecionaCotista($event)"
                    [cnpjAgente]="cnpjUsuario"
                    [readonly]="cnpjUsuario">
                </app-select-cotista>
            </div>
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="dataSubscricaoInicial" >Data da subscrição inicial:</label>
                <bn-datepicker
                    name="dataSubscricaoInicial"
                    idInput="dataSubscricaoInicial"
                    ngDefaultControl
                    formControlName="dataSubscricaoInicial">
                </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="dataSubscricaoFinal">Data da subscrição final:</label>
                <bn-datepicker
                    name="dataSubscricaoFinal"
                    idInput="dataSubscricaoFinal"
                    ngDefaultControl
                    formControlName="dataSubscricaoFinal">
                </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-2">
                <label class="form-label" for="cota">Cota: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Tipos de categoria de cotas do fundo"></i></label>
                <select class="form-select" name="cota" id="cota" ngDefaultControl formControlName="categoriaCota">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let categoria of categorias"
                        [ngValue]="categoria">{{ categoria }}
                    </option>
                </select>
            </div>
        </div>
    </form>
</div>
<app-subscricao-cotas-listagem
    [msgSemResultado]="msgSemResultado"
    [dataHoraResultado]="dataHoraResultado"
    [subscricoes]="subscricoes"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    [podeCadastrarSubscricao]="podeCadastrarSubscricao"
    (aoMudarPagina)="mudancaPagina($event)"
    (exportarSubscricoes)="exportarSubscricoes()"
    (selecionado)="selecionaCotista">
</app-subscricao-cotas-listagem>
